"use client";
import {Crow} from "@aops-trove/crow";
import {useEffect} from "react";

export default function Cro() {
	useEffect(() => {
		window["Crow"] = Crow();
	}, []);

	return <></>;
}
